export enum OfficeType {
  FRONT_OFFICE = "Front Office",
  BACK_OFFICE = "Back Office",
  ALL = "All",
}

export enum StepStatus {
  COMPLETE = "Complete",
  INCOMPLETE = "Incomplete",
}

export enum StepType {
  APP = "App",
  KNOWLEDGE = "Knowledge",
  HYBRID = "Hybrid",
}

export interface AppInputSchema {
  name: string;
  label: string;
  description: string;
  type: "text" | "password" | "number";
  required?: boolean;
  placeholder?: string;
}

export interface AppOption {
  id: string;
  name: string;
  requiredInputs?: AppInputSchema[];
  isInstalled?: boolean;
  installationParams?: { [key: string]: any };
  appCategories?: string[];
}

export interface FileConfig {
  maxFiles?: number;
  maxSizeMB?: number;
  allowedTypes?: string[];
}

export interface KnowledgeFieldSchema {
  name: string;
  label: string;
  type: "text" | "number" | "textarea" | "boolean" | "file";
  placeholder?: string;
  options?: { value: string; label: string }[];
  required?: boolean;
  fileConfig?: FileConfig;
}

export interface FileDetails {
  name: string;
  size: number;
  type: string;
  url?: string;
  id: string;
}

export interface KnowledgeItem {
  id: string;
  [key: string]: any | FileDetails[];
}

export interface StepConfig {
  type?: StepType.APP | StepType.KNOWLEDGE;
  availableApps?: AppOption[];
  knowledgeSchema?: KnowledgeFieldSchema[];
  isStructuredKnowledge?: boolean;
  maxKnowledgeItems?: number;
}

export interface StepCurrentConfig {
  selectedAppId?: string;
  knowledgeData?: KnowledgeItem[] | string;
  type?: StepType.HYBRID | StepType.APP | StepType.KNOWLEDGE;
  appInstallationParams?: { [key: string]: any };
  internalAppName?: string;
  visibleParams?: { [key: string]: any };
}

export interface FeedbackEntry {
  id: string;
  text: string;
  date: string;
  author: string;
  attachments?: FileDetails[];
}

export interface WorkflowStepData {
  id: string;
  name: string;
  status: StepStatus;
  type: StepType;
  details?: string | { [key: string]: any };
  config?: StepConfig;
  currentConfig?: StepCurrentConfig;
  requiresConfiguration?: boolean;
  feedbackHistory?: FeedbackEntry[];
  hasFeedback?: boolean;
}

export interface WorkflowProcessData {
  id: string;
  name: string;
  steps: WorkflowStepData[];
  relevantAppCategory?: string;
}

export interface WorkflowCategoryData {
  id: string;
  name: string;
  type: OfficeType.FRONT_OFFICE | OfficeType.BACK_OFFICE;
  description?: string;
  processes: WorkflowProcessData[];
  feedbackHistory?: FeedbackEntry[];
  hasFeedback?: boolean;
}

export interface ProcessRootState {
  workflows: WorkflowState;
  processUi: ProcessUIState;
}

export interface WorkflowState {
  categories: WorkflowCategoryData[];
  loading: boolean;
  error: string | null;
}

export interface ProcessUIState {
  selectedOfficeType: OfficeType;
  selectedStep: WorkflowStepData | null;
  isStepDetailModalOpen: boolean;
  feedbackTarget: {
    type: "category" | "step";
    id: string;
    name: string;
    feedbackHistory?: FeedbackEntry[];
  } | null;
  isFeedbackModalOpen: boolean;
  isCanvasViewOpen: boolean;
  canvasViewCategory: WorkflowCategoryData | null;
}

export interface SubmitStepPayload {
  categoryId: string;
  processId: string;
  stepId: string;
  config: StepCurrentConfig;
}

export interface SubmitFeedbackPayload {
  targetType: "category" | "step";
  targetId: string;
  feedbackText: string;
  newAttachments?: File[];
}

export interface DeleteStepPayload {
  categoryId: string;
  processId: string;
  stepId: string;
}
